<template>
	<v-row>
		<v-col cols="10" class="pt-4">
			<v-combobox
				v-model.trim="type"
				:items="items"
				:search-input.sync="search"
				placeholder="Solicitar un documento Ej: patente comercial"
				outlined
				dense
				filled
				hint="Escriba el nombre del documento y presione agregar"
				persistent-hint
				:error-messages="isDuplicated ? 'Ya existe el documuento' : ''"
				:disabled="addLoading"
				clearable
				single-line
				class="mb-5"
				no-data-text="No hay Documentos agregados"
			>
			</v-combobox>
		</v-col>
		<v-col cols="12" sm="2" class="mt-2">
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn
						small
						block
						:loading="addLoading"
						:color="isDuplicated && search ? 'error' : 'success'"
						@click="submit"
					>
						Agregar
						<v-icon right v-on="on">mdi-plus</v-icon>
					</v-btn>
				</template>
				Enviar invitación
			</v-tooltip>
		</v-col>
		<v-col cols="12">
			<v-expand-transition>
				<v-row v-if="Boolean(chipSelect)">
					<v-col cols="12" md="5">
						<v-file-input
							v-model="document"
							outlined
							filled
							:disabled="loading"
							:label="`Subir el documento ${chipSelect.text}`"
							dense
							single-line
						/>
					</v-col>
					<v-col cols="12" md="5">
						<v-menu
							ref="menu"
							v-model="menu"
							:close-on-content-click="false"
							:return-value.sync="date"
							transition="scale-transition"
							offset-y
							min-width="290px"
						>
							<template v-slot:activator="{ on }">
								<v-text-field
									v-model="date"
									dense
									filled
									readonly
									clearable
									outlined
									:disabled="loading"
									placeholder="*opcional"
									label="Fecha de vencimiento"
									v-on="on"
								></v-text-field>
							</template>
							<v-date-picker v-model="date" outlined locale="es" no-title scrollable>
								<v-spacer></v-spacer>
								<v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
								<v-btn text color="primary" @click="$refs.menu.save(date)">
									OK
								</v-btn>
							</v-date-picker>
						</v-menu>
					</v-col>
					<v-col cols="12" md="2" class="mt-2">
						<v-btn block :loading="loading" small color="primary" @click="upload">
							Subir
						</v-btn>
					</v-col>
				</v-row>
			</v-expand-transition>
		</v-col>
		<template v-if="hasDocuments || hasTypeDocuments">
			<v-col v-if="hasDocuments" sm="12" :md="hasTypeDocuments ? '6' : '12'">
				<v-list two-line dense>
					<v-subheader>Documentos disponibles</v-subheader>
					<v-list-item-group color="primary" style="max-height: 180px; overflow: auto;">
						<template v-for="(req, i) in place.typeDocuments">
							<template v-if="req">
								<v-list-item
									v-if="place.documents[i]"
									:key="i"
									:disabled="disabledList"
									tile
									link
									target="_blank"
									:href="place.documents[i].url"
								>
									<v-list-item-avatar>
										<v-icon
											v-if="itsDue(place.documents[i].date)"
											color="warning"
										>
											mdi-clock-alert-outline
										</v-icon>
										<v-icon v-else color="success">
											mdi-checkbox-marked-circle-outline
										</v-icon>
									</v-list-item-avatar>
									<v-list-item-content class="text-left">
										<v-list-item-title class="text-capitalize">
											{{ place.documents[i].text }}
										</v-list-item-title>
										<v-list-item-subtitle
											v-if="itsDue(place.documents[i].date)"
											style="font-size: 8pt;"
											class="warning--text"
										>
											Caducado el {{ place.documents[i].date }}
										</v-list-item-subtitle>
										<v-list-item-subtitle v-else style="font-size: 8pt;">
											Creado:
											{{ createdAt(place.documents[i].createdAt) }}
											{{
												place.documents[i].date &&
													`- Vence: ${place.documents[i].date}`
											}}
										</v-list-item-subtitle>
									</v-list-item-content>
									<v-list-item-action>
										<v-btn
											class="elevation-0"
											x-small
											color="accent"
											fab
											:disabled="disabledList"
											@click.prevent="openDialogDelete(i)"
										>
											<v-icon>mdi-close</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</template>
						</template>
					</v-list-item-group>
				</v-list>
			</v-col>

			<v-col v-else>
				<empty title="Sin disponibles" msj="No hay documentos disponibles" />
			</v-col>
			<v-col v-if="hasTypeDocuments" sm="12" :md="hasDocuments ? '6' : '12'">
				<v-list two-line dense>
					<v-subheader>Documentos pendientes</v-subheader>
					<v-list-item-group color="primary" style="max-height: 180px; overflow: auto;">
						<template v-for="(req, i) in place.typeDocuments">
							<template v-if="req !== null && !place.documents[i]">
								<v-list-item
									:key="i"
									tile
									:disabled="disabledList"
									@click="toggleSelect(req, i)"
								>
									<v-list-item-avatar>
										<v-icon color="warning">mdi-file-question-outline</v-icon>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title class="text-left text-capitalize">{{
											req.text
										}}</v-list-item-title>
									</v-list-item-content>
									<v-list-item-action>
										<v-btn
											class="elevation-0"
											x-small
											color="accent"
											fab
											:disabled="disabledList"
											@click.stop="openDialogDelete(i)"
										>
											<v-icon>mdi-close</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</template>
						</template>
					</v-list-item-group>
				</v-list>
			</v-col>
			<v-col v-else>
				<empty title="Sin pendientes" msj="No hay documentos pendientes" />
			</v-col>
		</template>
		<v-col cols="12">
			<template v-if="hasWorkOrders">
				<v-list two-line dense class="backgroundTransparent">
					<v-subheader>Ordenes de trabajo</v-subheader>
					<v-menu v-model="menuOT" :close-on-content-click="false" max-width="290">
						<template v-slot:activator="{ on, attrs }">
							<v-text-field
								clearable
								dense
								solo
								outlined
								filled
								class="my-3 ml-3"
								label="Seleccione un mes"
								readonly
								v-bind="attrs"
								v-on="on"
								@click:clear="month = null"
								hide-details
								:value="dateFormatted"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="month"
							@change="menuOT = false"
							no-title
							type="month"
							locale="es"
						></v-date-picker>
					</v-menu>

					<v-btn
						v-if="workOrdersTypes.includes('agro-services')"
						small
						rounded
						class="ma-2"
						@click="agro = !agro"
						color="primary"
						v-model="agro"
						>Agro Services</v-btn
					>
					<v-btn
						v-if="workOrdersTypes.includes('ciclo-urbano')"
						small
						rounded
						class="ma-2"
						color="primary"
						@click="ciclo = !ciclo"
						v-model="ciclo"
						>Jardineriaa</v-btn
					>
					<v-btn
						v-if="workOrdersTypes.includes('urban-plagas')"
						small
						rounded
						class="ma-2"
						color="primary"
						@click="plagas = !plagas"
						v-model="plagas"
						>Control de Plagas</v-btn
					>
					<v-btn
						v-if="workOrdersTypes.includes('biotec-plagas')"
						small
						rounded
						class="ma-2"
						color="primary"
						@click="biotec = !biotec"
						v-model="biotec"
						>Biotec</v-btn
					>
					<br />
					<!-- <v-btn color="primary" small @click="exportOtToPdf" class="my-2">
					descargar ordenes de trabajo
				</v-btn> -->
					<v-list-item-group
						v-if="workOrders.length"
						color="primary"
						class="overflow-y backgroundTransparent"
					>
						<template v-for="workOrder in workOrders">
							<template v-if="workOrder">
								<v-list-item
									v-if="workOrder"
									:key="workOrder.type + ' ' + workOrder.id"
									tile
									link
									target="_blank"
									:href="generateWorkOrderLink(workOrder)"
								>
									<v-list-item-content class="text-left">
										<v-list-item-title class="text-capitalize">
											{{ formatWorkOrderName(workOrder.type) }} N°OT:
											{{ workOrder.id }} -
											{{
												workOrder.person.firstName +
													workOrder.person.lastName
											}}
										</v-list-item-title>
										<v-list-item-subtitle style="font-size: 8pt;">
											Fecha:
											{{ workOrder.date }}
										</v-list-item-subtitle>
									</v-list-item-content>
									<v-btn
										:key="workOrder.id"
										small
										class="warning"
										target="_blank"
										:href="workOrderCertificateLink(workOrder)"
										v-if="workOrder.type === 'rrplagas'"
									>
										Editar OT
									</v-btn>
								</v-list-item>
							</template>
						</template>
					</v-list-item-group>
					<template v-else>
						<empty
							title="Sin ordenes de trabajo "
							msj="No hay ordenes de trabajo en este mes"
						/>
					</template>
				</v-list>
			</template>
			<template v-else>
				<v-col>
					<empty msj="No hay ordenes de trabajo" />
				</v-col>
			</template>
		</v-col>
		<dialog-confirm
			title="Estas seguro de eliminar"
			:dialog="dialogConfirm"
			:close="() => closeDialogDelete()"
			:confirm="() => confirmDelete()"
			:loading="disabledList"
		/>
	</v-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import Empty from '@/components/ui/DataEmpty';

export default {
	components: { Empty, DialogConfirm: () => import('@/components/ui/DialogConfirm') },
	props: {
		place: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			menuOT: false,
			month: moment()
				.date(1)
				.format('YYYY-MM'),
			dialogConfirm: false,
			itemToDelete: null,
			date: null,
			menu: null,
			document: null,
			disabledList: false,
			loading: false,
			addLoading: false,
			type: null,
			search: '',
			chipSelect: null,
			indexSelected: '',
			persons: [],
			plagas: false,
			agro: false,
			ciclo: false,
			biotec: false,
		};
	},
	computed: {
		dateFormatted() {
			return this.month ? moment(this.month).format('MMMM YYYY') : '';
		},
		workOrders() {
			let orders = [];
			this.place.lodgings.forEach(lod => {
				if (lod.workOrder.length > 0) {
					lod.workOrder.forEach((wo, idx) => {
						if (moment(wo[1]).isSame(this.month, 'month'))
							orders.push({
								id: wo.id,
								type: wo.type,
								person: this.getPerson(lod.person),
								lodId: lod._id,
								index: idx,
								date: wo.date,
								place: this.place.name,
							});
					});
				}
			});

			if (!this.agro && !this.ciclo && !this.plagas)
				return orders.sort((a, b) => b.id - a.id);

			let filters = [];
			if (this.agro) filters.push('agro-services');
			if (this.ciclo) filters.push('ciclo-urbano');
			if (this.plagas) filters.push('urban-plagas');

			let results = [];
			if (filters.length > 0) {
				orders.forEach(item => {
					if (filters.includes(item.type)) {
						results.push(item);
					}
				});
			}

			return results.sort((a, b) => b.id - a.id);
		},
		workOrdersTypes() {
			let woTypes = [];
			this.place.lodgings.forEach(lod => {
				if (lod.workOrder.length > 0) {
					lod.workOrder.forEach(wo => {
						if (moment(wo[1]).isSame(this.month, 'month'))
							if (!woTypes.includes(wo[wo.length - 1]))
								woTypes.push(wo[wo.length - 1]);
					});
				}
			});

			return woTypes;
		},
		isShare() {
			return this.place.ownerEmail !== this.userProfile.email;
		},
		hasDocuments() {
			return this.place.documents.length && this.place.documents.some(item => item !== null);
		},
		hasWorkOrders() {
			return this.place.lodgings.some(lod => {
				return lod.workOrder.length > 0;
			});
		},
		hasTypeDocuments() {
			return this.place.typeDocuments.some(
				(item, i) => item !== null && !this.place.documents[i]
			);
		},
		// verify duplicate documents
		isDuplicated() {
			let search = this.search || '';
			search = search.toLowerCase();
			return this.place.typeDocuments.some(
				typeDocument => typeDocument !== null && typeDocument.text.toLowerCase() === search
			);
		},
		// set documents for items combobox
		items() {
			if (!this.place) return [];
			let places = this.places.filter(place => place._id !== this.place._id);
			const allTypeDocuments = places.reduce((allTypeDocuments, { typeDocuments }) => {
				return allTypeDocuments.concat(
					typeDocuments.map(el => {
						if (el) return el.text;
					})
				);
			}, []);
			if (allTypeDocuments.length) return allTypeDocuments.filter(item => item !== undefined);
			return [];
		},
		...mapGetters({
			places: 'Place/places',
			listPerson: 'Person/persons',
		}),
	},
	methods: {
		getPerson(id) {
			return this.listPerson.find(person => person._id == id);
		},
		openDialogDelete(item) {
			this.itemToDelete = item;
			this.dialogConfirm = true;
		},
		closeDialogDelete() {
			this.itemToDelete = null;
			this.dialogConfirm = false;
		},
		itsDue(date) {
			return moment(date).isBefore(moment().format());
		},
		createdAt(createdAt) {
			if (createdAt) return moment(createdAt).format('l');
			else return 'Sin fechas';
		},
		generateWorkOrderLink(workOrder) {
			return `#/${workOrder.type}/${workOrder.lodId}/work-order/${workOrder.index}`;
		},
		workOrderCertificateLink(workOrder) {
			return `#/${workOrder.type}/certificate/${workOrder.lodId}/work-order/${workOrder.index}`;
		},
		// new document request pending
		async submit() {
			if (!this.isDuplicated && this.search) {
				this.addLoading = true;
				const payload = {
					_id: this.place._id,
					typeDocuments: { text: this.search },
				};
				await this.setTypeDocument(payload);
				this.search = '';
				this.addLoading = false;
			}
		},
		async exportOtToPdf() {
			let sortedOrders = this.workOrders;
			try {
				const pdf = await this.generateOtPdfReport(sortedOrders);
				let blob = new Blob([pdf], { type: 'application/pdf' });
				let link = document.createElement('a');
				link.href = window.URL.createObjectURL(blob);
				link.download = 'Ordenes de Trabajo.pdf';
				link.click();
			} catch (e) {
				this.snackbar({
					content: e.message,
					color: 'error',
				});
			}
		},
		// upload a new document
		async upload() {
			if (this.document && this.place.typeDocuments.length) {
				this.loading = true;
				this.disabledList = true;
				let data = {
					_id: this.place._id,
					documents: this.document,
					typeDocuments: [...this.place.typeDocuments],
				};
				data.typeDocuments[this.indexSelected] = {
					text: this.chipSelect.text,
					done: true,
					isEditing: true,
					date: this.date,
				};
				await this.uploadDocument(data);
				this.indexSelected = null;
				this.date = null;
				this.document = null;
				this.chipSelect = null;
				this.loading = false;
				this.disabledList = false;
			}
		},
		async confirmDelete() {
			if (!this.isShare) {
				this.disabledList = true;
				await this.deleteDocument({
					idPlace: this.place._id,
					indexDoc: this.itemToDelete,
				});
				this.closeDialogDelete();
				this.disabledList = false;
			} else
				this.snackbar({
					content: 'No puedes eliminar un documento de un establecimiento compartido',
					color: 'error',
				});
		},
		// toggle select chip
		toggleSelect(document, index) {
			if (this.chipSelect) {
				this.indexSelected = null;
				this.document = null;
				this.chipSelect = null;
			} else {
				this.chipSelect = document;
				this.indexSelected = index;
			}
		},
		formatWorkOrderName(name) {
			if (name === 'biotec-plagas-certificate') return 'Certificado Biotec Plagas';
			else return name;
		},
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
		}),
		...mapActions({
			generateOtPdfReport: 'Place/generateOtPdfReport',
			uploadDocument: 'Place/upload',
			setTypeDocument: 'Place/setTypeDocument',
			deleteDocument: 'Place/deleteDocument',
			getPersonsInPlace: 'Person/getPersonsInPlace',
		}),
	},
};
</script>
